module.exports = __webpack_public_path__ + "static/img/img_welecome.bbe3bee0.png";